/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgencyState } from './agency-state';


export interface AgencyStatus { 
    active?: boolean;
    agencyDisabled?: boolean;
    agencyEditRole?: boolean;
    agencyWizardRole?: boolean;
    allowsLogin?: boolean;
    associatedEmailTemplateOid?: string;
    homeUri?: string;
    id?: AgencyStatus.IdEnum;
    menuOrder?: number;
    referralModuleRole?: boolean;
    resubmissionNotesRole?: boolean;
    sequence?: number;
    showInMenu?: boolean;
    status?: string;
    updateAgencyStateTo?: AgencyState;
    userInstructions?: string;
    version?: number;
}
export namespace AgencyStatus {
    export const IdEnum = {
        Approved: 'Approved',
        BeingReviewed: 'Being Reviewed',
        Denied: 'Denied',
        Inactive: 'Inactive',
        NotSubmitted: 'Not Submitted',
        RenewalAlert: 'Renewal Alert',
        RenewalExpired: 'Renewal Expired',
        RenewalWarning: 'Renewal Warning',
        ResubmissionRequired: 'Resubmission Required',
        ResubmissionRequiredImmediately: 'Resubmission Required Immediately'
    } as const;
    export type IdEnum = typeof IdEnum[keyof typeof IdEnum];
}


